<template>
  <div class="UserLogin">
    <el-dialog :visible.sync="dialogVisible" width="400px">
      <div class="login-menu" v-if="!imageBool">
        <p class="title">用户登录</p>
        <el-form ref="loginForm" :model="loginForm" :rules="rules">
          <el-form-item prop="userName">
            <el-input
              v-model="loginForm.userName"
              placeholder="请输入手机号"
              prefix-icon="el-icon-user"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <el-button @click="submitForm('loginForm')" :loading="loginLoading">登录</el-button>
      </div>
      <div class="image-verify-box" style="position: relative;" v-if="imageBool">
        <div>
          <img id="smallImage" :src="'data:image/png;base64,'+ imageList.smallImage"
               :style="'top:'+ imageList.yHeight + 'px;left:' + smallWidth + 'px'">
          <img id="bigImage" :src="'data:image/jpeg;base64,'+ imageList.bigImage">
          <div class="el-icon-refresh" @click="refreshImage"></div>
        </div>
        <el-slider
          v-model="sliderValue"
          :show-tooltip="false"
          :min="0"
          :max="320"
          :class="imageSliderState"
          @change="changeImageSlider"
          @input="changeSmallImage">
        </el-slider>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { loginByImg } from '@/utils/router/login.api'
import {getImageVerifyCode} from "../../utils/plugin/verifyImage";
export default {
  name: 'UserLogin',
  data() {
    var validateMobilePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不可为空"));
      } else {
        if (value !== "") {
          var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的手机号码"));
          }
        }
        callback();
      }
    };
    var valPwd = (rule, value, callback) => {
      if (/^[0-9a-zA-Z]{8,}$/.test(value) && isNaN(value)) {
        callback();
      } else {
        callback(new Error('必须是8位以上字母和数字组合'));
      }
    };
    return {
      dialogVisible: false,
      loginForm: {
        userName: "",
        password: "",
        imageVerification: ""
      },
      rules: {
        userName: [
          {required: true, message: '请输入'},
          {validator: validateMobilePhone, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入'},
          {validator: valPwd, trigger: 'blur'}
        ],
      },
      loginLoading: false,
      //验证码
      imageBool: false,
      sliderValue: 8,
      smallWidth: '0px',
      imageSliderState: '',
      imageList: {
        bigImage: '',
        smallImage: '',
        xWidth: 0,
        yHeight: 0,
      },
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.loginForm = Object.assign({});
    },
    //获取图形
    getImage() {
      getImageVerifyCode().then(res => {
        if (res && res.data.data) {
          this.imageBool = true
          this.imageList = res.data.data
        }
      })
    },
    //验证图形刷新
    refreshImage() {
      this.imageSliderState = ""
      this.sliderValue = 8
      this.smallWidth = '0px'
      this.getImage()
    },
    //图形验证
    changeImageSlider(value) {
      if (Math.abs(this.imageList.xWidth - value) < 10) {
        this.imageSliderState = 'verify-success'
        this.imageBool = false
        this.loginLoading = true
        setTimeout(res => {
          this.setLogin()
        }, 1000)
      } else {
        this.imageSliderState = 'verify-fail'
        setTimeout(res => {
          this.refreshImage()
        }, 1000)
      }
    },
    //滑动拼图
    changeSmallImage(value) {
      value < 260 && (this.smallWidth = value)
    },
    changeimgcode() {
      var num = Math.ceil(Math.random() * 10);
      this.imgcode = "/portal/reader/imageVerification?" + num;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.refreshImage()
        } else {
          this.$message('验证未通过');
          return false;
        }
      });
    },
    setLogin(row) {
      loginByImg({
        userName: this.loginForm.userName,
        password: this.$md5(this.loginForm.password),
        moveLength: this.smallWidth
      }).then((res) => {
        if (res && res.data.code === 200) {
            this.$message('登录成功')
            this.dialogVisible = false;
             this.$store.commit("setUserInfo", {
              userId: res.data.data.id,
              userName: res.data.data.userName,
              nickname: res.data.data.nickname,
            })
            sessionStorage.setItem("portal_user_info", JSON.stringify(res.data.data))
            location.reload()
        }else {
          this.$alert(res.data.message);
          this.loginLoading = false;
          this.imageBool = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.UserLogin {
  position: relative;
}
/deep/.el-dialog {
  height: 390px;
  position: fixed;
  top: 0;
  right: 10%;
}
.login-menu {
  width: 334px;
  height: 328px;
  margin: auto;
  .title {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 34px;
    text-align: center;
  }
  .el-button {
    width: 100%;
    height: 40px;
    background-color: #654719;
    color: #fff;
  }
}
/deep/.el-input--small .el-input__inner {
  height: 44px;
  border: 1px solid #654719;
}

.image-verify-box {
  position: relative;

  /deep/ .verify-success {
    .el-slider__button {
      background: #2ac845;
    }
  }

  /deep/ .verify-fail {
    .el-slider__button {
      background: #ff0000;
    }
  }

  /deep/ .el-slider {
    width: 320px;
    height: 40px;
    line-height: 40px;
    background-image: none;
    background-color: rgba(0, 0, 0, 0.03);
    border: solid 1px #eee;
    text-align: center;
    font-size: 18px;
    color: #0C0C0C;
    position: relative;
  }

  /deep/ .el-slider__runway {
    width: 300px;
    height: 40px;
    line-height: 40px;
    background: none;
    border: none;
    text-align: center;
    font-size: 18px;
    color: #0C0C0C;
    position: relative;
    margin: 0 0;
  }

  /deep/ .el-slider__runway:after {
    content: "请完成安全认证";
  }

  /deep/ .el-slider__button-wrapper {
    width: 40px;
    height: 46px;
    border-radius: 5px;
    border: 1px solid #409EFF;
    background-color: #409EFF;
    cursor: pointer;
    margin-left: 20px;
    position: absolute;
    top: -4px;
  }

  /deep/ .el-slider__bar {
    height: 40px;
  }

  #smallImage {
    width: 60px;
    height: 60px;
    position: absolute;
  }

  #bigImage {
    width: 320px;
    height: 180px;
  }

  .el-icon-refresh {
    color: #e0e0e0;
    cursor: pointer;
    font-size: 20px;
    position: relative;
    left: 291px;
    top: -177px;
  }

  .el-icon-refresh:hover {
    color: #fff;
  }
}
</style>
